/**
 * String enums for external assistant embed options (URL query params and `XA_AI_EMBED.init`).
 * Enum member values are the exact strings stored in the query string and expected by the Angular route.
 */

/** Shape of the built-in floating launcher when the embed `launcher` flag is true. */
export enum EmbedLauncherKind {
  Bubble = 'bubble',
  Button = 'button'
}

/** Corner for the fixed panel and matching launcher placement. */
export enum EmbedPanelCorner {
  BottomRight = 'bottom-right',
  BottomLeft = 'bottom-left',
  TopRight = 'top-right',
  TopLeft = 'top-left'
}

/** Preset icon for bubble/button chrome (avoids remote `iconUrl` when set to Chat or Help). */
export enum EmbedLauncherIconPreset {
  None = 'none',
  Chat = 'chat',
  Help = 'help',
  /** Portal Agentix mark (uses registered `agentix` SVG icon). */
  Agentix = 'agentix'
}

/** Parent-to-iframe `postMessage` actions (SDK → Angular). */
export enum EmbedPanelMessageAction {
  Open = 'open',
  Close = 'close',
  Toggle = 'toggle'
}

/** Envelope type for iframe → parent messages (assistant chrome living outside the iframe). */
export const EMBED_CHILD_TO_PARENT_TYPE = 'xa-ai-embed-from-child' as const;

/** Iframe → parent `postMessage` actions (Angular route → host page / embed SDK). */
export enum EmbedChildToParentMessageAction {
  AssistantReady = 'assistant-ready',
  PanelClosed = 'panel-closed'
}
